<template>
  <div class="extended-select-dropdown-controls">
    <div
      v-if="errorText"
      class="extended-select-dropdown-error"
    >
      <div class="extended-select-dropdown-error__icon">
        <MIcon :icon="warningSign" />
      </div>
      <div class="selected-items-error__error-text">
        {{ errorText }}
      </div>
    </div>
    <div class="extended-select-dropdown-controls__buttons">
      <MButton
        class="extended-select-dropdown-controls__cancel"
        secondary
        @click="$emit('cancel')"
      >
        {{ cancelText }}
      </MButton>
      <MButton
        :disabled="!allowSave"
        :is-loading="isLoadingButton"
        class="extended-select-dropdown-controls__apply"
        @click="$emit('apply')"
      >
        {{ okText }}
      </MButton>
    </div>
  </div>
</template>

<script>
  import MButton from 'components/Inputs/Basic/MButton';
  import MIcon from 'components/Design/MIcon';
  import warningSign from 'assets/icons/warningSign.svg';

  import getTr from 'translation';

  export default {
    name: 'ExtendedSelectDropdownControls',
    components: {MButton, MIcon},
    props: {
      okText: {
        type: String,
        default: 'OK'
      },
      cancelText: {
        type: String,
        default: () => getTr('cancel')
      },
      allowSave: {
        type: Boolean,
        default: true
      },
      errorText: {
        type: String,
        default: ''
      },
      isLoadingButton: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        warningSign
      };
    }
  };
</script>

<style>
  .extended-select-dropdown-controls {
    display: flex;

    flex-direction: column;

    height: 100%;
  }

  .extended-select-dropdown-controls__buttons {
    display: flex;

    justify-content: flex-end;
    align-items: flex-end;

    height: 100%;
  }

  .extended-select-dropdown-controls__cancel {
    margin-right: 12px;
  }

  .extended-select-dropdown-error {
    display: flex;
  }

  .extended-select-dropdown-error__icon {
    color: var(--error-color);

    width: 20px;
    height: 20px;
  }

  .selected-items-error__error-text {
    font-size: 12px;

    color: var(--secondary-text-color);

    width: 87%;

    margin-left: 8px;
  }
</style>
